var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCocktailAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68656 2.45095C6.51837 2.06788 6.07525 1.89536 5.69683 2.06561C5.3184 2.23586 5.14797 2.68442 5.31616 3.06749L6.51384 4.79533H5.00159C4.17773 4.79533 3.70745 5.74741 4.20177 6.41458L6.62846 9.68986C8.3892 9.35207 10.2128 9.52885 11.8837 10.2054C13.3111 10.7834 14.8737 10.9286 16.3813 10.6234L16.7326 10.5523L19.7982 6.41458C20.2925 5.74741 19.8223 4.79533 18.9984 4.79533H8.15494L6.68656 2.45095Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2502 15.9277L7.65479 11.075C8.89804 10.9589 10.1569 11.1412 11.3267 11.6149C12.6415 12.1473 14.0528 12.3709 15.4554 12.276L12.7498 15.9277V20.4819H14.9993C15.4135 20.4819 15.7492 20.8218 15.7492 21.241C15.7492 21.6602 15.4135 22 14.9993 22H9.00073C8.58661 22 8.2509 21.6602 8.2509 21.241C8.2509 20.8218 8.58661 20.4819 9.00073 20.4819H11.2502V15.9277Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktailAlt);
export default __webpack_public_path__ + "static/media/cocktail-alt.3dc076884c595b148826e9b0cb3c751c.svg";
export { ForwardRef as ReactComponent };